import { Box, FormControl, FormGroup, FormLabel } from "@material-ui/core";
import InputBox from "../atoms/input_box";

const TextInputGroup = (props) => {
  const { label, value, onChange, multiline, rows, placeholder } = props;
  return (
    <FormGroup>
      <FormLabel>{label}</FormLabel>
      <FormControl variant="filled" component={Box} width="100%">
        <InputBox
          value={value}
          onChange={onChange}
          multiline={multiline}
          rows={rows}
          placeholder={placeholder}
        />
      </FormControl>
    </FormGroup>
  );
};

export default TextInputGroup;
